import { Typography, CircularProgress, Box, Snackbar } from '@mui/material';
import { Button } from 'design-system';
import { useState } from 'react';
import { Link } from 'react-router';
import { auth } from 'services/firebase';
import { getRoutePrefix } from 'services/theming';
import useUser from 'hooks/useUser';
import refreshFirebaseUser from 'utils/refresh-firebase-user';
import InactiveProfile from 'images/InactiveProfile';
import { FormType } from 'generated/graphql';

const InactiveAccount = () => {
  const [checking, setChecking] = useState(false);
  const [message, setMessage] = useState('');
  const { user, onLogout } = useUser();

  return (
    <Box
      sx={(theme) => ({
        textAlign: 'center',
        padding: theme.spacing(2),
        background: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: theme.spacing(10, 'auto', 0),
        maxWidth: 450,
        borderRadius: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
          minHeight: 'calc(100vh - 55px)',
        },
      })}
    >
      <Box component={InactiveProfile} sx={{ maxWidth: 200 }} />
      <Typography
        variant="h6"
        color="primary"
        sx={(theme) => ({
          margin: theme.spacing(2, 0),
        })}
      >
        Your profile is inactive
      </Typography>
      <Typography color="textSecondary">
        It&apos;s been a while since your last order, and we&apos;d love to welcome you back to the platform. <br />
      </Typography>
      <Typography color="textSecondary" sx={(theme) => ({ fontWeight: theme.typography.fontWeightBold, marginTop: 1 })}>
        To have your profile re-activated please email us.
      </Typography>
      <Box
        sx={(theme) => ({
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          margin: theme.spacing(3, 0),
          alignItems: 'center',
          gap: theme.spacing(1),
        })}
      >
        {checking ? (
          <CircularProgress size={32} color="secondary" />
        ) : (
          <>
            <Button
              color="secondary"
              variant="contained"
              onClick={async () => {
                try {
                  setChecking(true);
                  const firebaseUser = auth.currentUser;
                  await refreshFirebaseUser({
                    user: firebaseUser,
                  });
                  const currentTokenResult = await firebaseUser?.getIdTokenResult(true);
                  if (currentTokenResult?.claims?.status === 'PendingApproval')
                    setMessage('Your profile is pending approval. Please try again later.');
                } catch (error) {
                } finally {
                  setChecking(false);
                }
              }}
            >
              Check Verification Status
            </Button>
            {user?.multiProfile && (
              <Button as={Link} to={`${getRoutePrefix()}/profile/${user.profileId}/${FormType.ProfileSwitcher}`}>
                Switch between profiles
              </Button>
            )}
            <Button onClick={onLogout}>logout</Button>
          </>
        )}
      </Box>
      <Snackbar open={!!message} onClose={() => setMessage('')} message={message} />
    </Box>
  );
};

export default InactiveAccount;
